import { formatDateYYYYMMDDDash } from '@cmd/ui-utilities';
export const DEFAULT_WEB_COMPONENT_TILE_SIZE = 'large';
export const getWebComponentTileSize = (width) => {
    if (width < 280) {
        return 'xsmall';
    }
    if (width < 320) {
        return 'small';
    }
    if (width < 400) {
        return 'medium';
    }
    return 'large';
};
export const getCssAssetUrl = (partition) => {
    const baseUrl = `https://assets.awscaccanalyticscore${partition === 'prod' ? '' : 'np'}.coxautoinc.com`;
    return `${baseUrl}/pages/landing-page/landing-page.css`;
};
export const getPkceFetchUrl = (baseUrl, partition) => {
    // Partition is undefined if the component is inside command center, so no need to modify the URL
    if (!partition) {
        return baseUrl;
    }
    // Otherwise, the component is outside command center in the common landing page,
    // so we need to use the command center url to fetch data
    const isProd = (partition || '') === 'prod';
    return `https://cmd-demo.awscaccanalyticscore${isProd ? '' : 'np'}.coxautoinc.com${baseUrl}`;
};
// Filters deltas to show YoY only, since web components default to "last year" date range
export const getWebComponentDeltas = (deltas) => {
    const yoyDelta = (deltas || []).find((delta) => delta.period === 'YoY');
    return yoyDelta
        ? [{ period: 'YoY', deltaValue: yoyDelta.value }]
        : [];
};
export const webComponentDefaultDateRange = () => {
    const lastYear = new Date().getFullYear() - 1;
    return {
        startDate: formatDateYYYYMMDDDash(new Date(lastYear, 0, 1)),
        endDate: formatDateYYYYMMDDDash(new Date(lastYear, 11, 31)),
        rangeType: 'Last Year',
    };
};
